import style from "css/myreservation.module.css";
import { useTranslation } from 'react-i18next';


function SegmentBar({ activeMenu, menuChange }) {
    const { t } = useTranslation()
    const menuOption = [
        'Today',
        '진행 예정',
        // '지난 내역'
    ];
    return (
        <div className={style.segment_container}>
            <div className={style.segment_wrapper}>
                {menuOption.map(menu => (
                    <div
                        key={menu}
                        className={`${style.segment_item} ${activeMenu === menu && style.active}`}
                        onClick={() => menuChange(menu)}
                    >
                        {t(`BTN.${menu}`)}
                    </div>
                ))}
            </div>
            <div className={style.segment_bottom}></div>
        </div >
    )
}

export default SegmentBar
